import * as create from "./create";
import * as edit from "./edit";
import * as detail from "./detail";

import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import ITransfer from "Types/Transfer";

export const GET_TRANSFERS = "[TRANSFER] GET_TRANSFERS";
export const GET_TRANSFERS_SUCCESS = "[TRANSFER] GET_TRANSFERS_SUCCESS";
export const GET_TRANSFERS_FAILED = "[TRANSFER] GET_TRANSFERS_FAILED";

export const IMPORT_TRANSFERS = "[TRANSFER] IMPORT_TRANSFERS";
export const IMPORT_TRANSFERS_SUCCESS = "[TRANSFER] IMPORT_TRANSFERS_SUCCESS";
export const IMPORT_TRANSFERS_FAILED = "[TRANSFER] IMPORT_TRANSFERS_FAILED";

export const SET_VALUE = "[TRANSFER EDIT] SET_VALUE";
export const CLEAR_VALUES = "[TRANSFER EDIT] CLEAR_VALUES";

export { create, edit, detail };

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function importTransfers(
	data?: any[],
	callback?: Callback<ITransfer[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: IMPORT_TRANSFERS });

		try {
			const { login } = getState();

			const response = await api.sendPost("/Transfer/Import", data, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: IMPORT_TRANSFERS_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: IMPORT_TRANSFERS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: IMPORT_TRANSFERS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function getTransfers(
	skip?: number,
	take: number = 10,
	filter?: any[],
	sort?: string,
	desc?: boolean,
	toExport?: boolean,
	callback?: Callback<ITransfer[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_TRANSFERS });

		try {
			const { login } = getState();

			const response = await api.sendGet(
				`/Transfer?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${
					filter || "&filters=null"
				}`,
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_TRANSFERS_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / (take || 10)),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_TRANSFERS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_TRANSFERS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
